<i18n>
{
  "fr": {
    "BugsCount": "Nombre d'anomalies causées",
    "ProjectsName": "Nom des projets",
    "Ratio": "Ratio",
    "TotalHours": "Nombre d'heures travaillées"
  }
}
</i18n>

<template>
  <section>
    <table class="table table-bordered table-hover">
      <thead class="thead-dark">
        <tr>
          <th
            v-t="'ProjectsName'"
            scope="col"/>
          <th
            v-t="'BugsCount'"
            scope="col"/>
          <th
            v-t="'TotalHours'"
            scope="col"/>
          <th
            v-t="'Ratio'"
            scope="col"/>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(projectBug, index) in projectsBugs"
          :key="index">
          <td>{{ projectBug.projectName }}</td>
          <td>{{ projectBug.bugsCount }}</td>
          <td>{{ projectBug.totalHours }}</td>
          <td>{{ projectBug.bugsCount / projectBug.totalHours | percentage }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('bugs', ['projectsBugs']),
  },
};
</script>
